import axios from '../base/axios';
import API_KEY from './key';

const GET_TOPRATED = 'flixfrenzy/redux/GET_TOPRATED';

// eslint-disable-next-line default-param-last
const topRatedReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TOPRATED:
      return action.payload;
    default:
      return state;
  }
};

export const getTopRated = () => (dispatch) => {
  axios.get(`movie/top_rated?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_TOPRATED,
      payload: res.data,
    });
  });
};

export default topRatedReducer;
